import styled, {css} from 'styled-components';
import * as symbols from '../../../../../assets/symbols/symbols/Symbols.css';
import {dFlex, dFlexCenter, dFlexColumn, alignCenter, justifyCenter} from '../../../../../globalVariables/GlobalFlex';

const boxStyles = css`
    background: var(--TA-color-bg-surface-default);
    border-radius: var(--radius-md);
    padding: var(--space-sm) var(--space-md);
`;

export const card = styled.div`
    ${boxStyles};
    margin: var(--space-lg);
`;

export const slotForm = styled.div`
    ${dFlexColumn};
    gap: var(--space-xl);
    padding: var(--space-lg) 10px var(--space-xl);
`;

export const slotInputBox = styled.div`
    ${boxStyles}

    input[type='time'] {
        font-size: 18px;
        font-weight: var(--font-weight-semibold, 600);
        text-align: end;
    }

    input[type='time']:not(.hasValue) {
        color: transparent;
    }
`;

export const dateBanner = styled.div`
    ${dFlexCenter};
    gap: var(--space-xs);
    height: 32px;
    width: 100%;
    padding: var(--space-sm);
    background: var(--color-state-info-bg);
    border-radius: var(--radius-md);
    font-size: var(--font-size-body, 16px);
    line-height: var(--line-height-body, 1.4);

    b {
        font-weight: var(--font-weight-bold, 700);
    }
`;

export const dateBannerIcon = styled.div`
    ${dFlex}
    ${alignCenter}
    ${justifyCenter}
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    background: center / 12px 13px no-repeat url("${symbols.calendarOutline}");
`;
